"use client";

import dynamic from "next/dynamic";

const PaintBoothDemoView = dynamic(() => import("@/views/PaintBoothDemo"), {
  ssr: false,
});

// The demo is intentionally ungated — it self-gates save/export/import and
// pushes logged-out visitors to sign up from inside the tool. Letting anyone
// reach it removes the biggest drop-off before they ever see the product.
export function PaintBoothDemoRoute() {
  return <PaintBoothDemoView />;
}
